class HomeService {
  constructor($rootScope, $http, $httpParamSerializer, emittentenService) {
    "ngInject";
    this.$rootScope = $rootScope;
    this.$http = $http;
    this.$httpParamSerializer = $httpParamSerializer;
    this.emittentenService = emittentenService;
  }

  getContent(id, lang) {
    if(id == null) {
      if(this.$rootScope.language == 'de') {
        id = 30;
      }else{
        id = 31;
      }
    }
    //return this.$http.get(this.$rootScope.config.api + 'page.php?page=' + id + '&lang=' + lang).then((result) => {
      return this.$http.get(this.$rootScope.config.api + 'cms/page?page=' + id + '&lang=' + lang, {
        headers: this.$rootScope.config.tokenHeader
      }).then((result) => {
      return result;
    }, (response) => {
      console.error(response);
    });
  }

  setContent(id, content) {
    if(id == null) {
      if(this.$rootScope.language == 'de') {
        id = 30;
      }else{
        id = 31;
      }
    }
    var header = {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
    if (this.$rootScope.config.tokenHeader) {
      header['x-access-token'] = this.$rootScope.config.tokenHeader['x-access-token'];
    }
    return this.$http({
      url: this.$rootScope.config.api + 'cms/page?&page_id=' + id,
      method: "PUT",
      headers: header,
      data: this.$httpParamSerializer({
        'content': content
      })
    }).then((result) => {
      return result;
    }, (response) => {
      console.error(response);
    });
  }

}

export default HomeService;



// WEBPACK FOOTER //
// ./client/app/components/home/home.service.js